import React from "react";
import { useTranslation } from "react-i18next";
import { LuExpand } from "react-icons/lu";

// MUI
import IconButton from "@mui/material/IconButton";

// Contexts
import { useMasteryMap } from "../context";

// Components
import Unit from "./unit";

// Styles
import styles from "./style.module.scss";

const Widget = () => {
  const { t } = useTranslation();
  // Context
  const { units, setShowModal } = useMasteryMap();

  const handleExpand = () => {
    setShowModal(true);
  };

  return (
    <div className='flex flex-col gap-2 w-full border-[1px] border-gray-200 p-4 rounded-lg'>
      <div className='flex flex-row gap-2 items-center justify-between border-b-[1px] border-gray-200 pb-2'>
        <h5 className="text-xl text-black dark:text-white">
          {t("masteryMap.title")}
        </h5>

        <IconButton
          color='secondary'
          onClick={handleExpand}
          classes={{
            root: styles.expandButton
          }}
        >
          <LuExpand className='w-6 h-6' />
        </IconButton>
      </div>

      <div className='flex flex-col gap-2'>
        {units.length === 0 && <div className='text-center text-md text-gray-400 dark:text-gray-300'>
          {t("masteryMap.no_units")}
        </div>}

        {units?.map((unit, index) => <Unit key={unit.id} unit={unit} index={index} />)}
      </div>
    </div>
  );
};

export default Widget;
